import { getApiSLice } from "utils/getApiBaseQuery";

export const filtersSlice = getApiSLice("dev").injectEndpoints({
  endpoints: (builder) => ({
    getSavedFilters: builder.query({
      query: (selectedRole) => ({
        url: `/collections/GetSavedFilterTemplates?roleCode=${selectedRole}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Filters" as const, id })),
              "Filters",
            ]
          : ["Filters"],
    }),
    addOrUpdateSavedFilter: builder.mutation({
      query: (newFilter) => ({
        url: "/collections/AddOrUpdateSavedFiltersTemplates",
        method: "POST",
        body: newFilter,
      }),
      invalidatesTags: ["Filters"],
    }),

    deleteSavedFilter: builder.mutation({
      query: (idToDelete: number) => ({
        url: `/collections/RemoveSavedFiltersTemplates?savedFiltersTemplatesID=${idToDelete}`,
        method: "POST",
      }),
      invalidatesTags: ["Filters"],
    }),
  }),
});

export const {
  useGetSavedFiltersQuery,
  useAddOrUpdateSavedFilterMutation,
  useDeleteSavedFilterMutation,
} = filtersSlice;
